import { useEffect, useState } from "react"
import { ReactComponent as ClockIcon } from "../../assets/images/icons/ic-clock.svg"
import { ReactComponent as ListIcon } from "../../assets/images/icons/ic-list.svg"
import { Each } from "../../common/Each"
import { capitalize, formatTimeV2, UTCtoLocal } from "../../utils"
import styles from "./EditionLessonsCard.module.css"
import Skeleton from "../Skeleton"

const EditionLessonsCard = ({ edition, active, style, loading }) => {

    const [lessons, setLessons] = useState([])
    console.log('style', style)

    useEffect(() => {
        if (edition) {
            let lessons = edition.modules.flatMap(module => module.lessons)
            setLessons(lessons.sort((a, b) => {
                if (a.starts_at && !b.starts_at) {
                    return -1
                }
                if (!a.starts_at && b.starts_at) {
                    return 1
                }
                return UTCtoLocal(a.starts_at) - UTCtoLocal(b.starts_at)
            }))
        }
    }, [edition])

    // Restituisce { day, month, weekday, year } da una data ISO, con locale italiano
    function parseDateParts(isoDate, locale = 'it-IT') {
        if (!isoDate) return { day: '', month: '', weekday: '', year: '' };
        const date = new Date(isoDate);
        const day = date.getDate();
        const year = date.getFullYear();
        // Mese e giorno della settimana in italiano
        const month = date.toLocaleString(locale, { month: 'long' });
        const weekday = date.toLocaleString(locale, { weekday: 'long' });
        return { day, month, weekday, year };
    }


    return (
        <div className={styles.container} style={style}>
            {!loading &&
                <>
                    <div className={styles.header}>
                        <ListIcon className={styles.icon} />
                        <div className={styles.title}>{parseDateParts(lessons[0]?.starts_at).month.toUpperCase()} {parseDateParts(lessons[0]?.starts_at).year}</div>
                    </div>

                    <div className={styles.lessons}>
                        <Each of={lessons} render={(lesson, index) => {
                            return (
                                <div className={styles.lesson} key={lesson.id}>
                                    <div className={styles.date}>{parseDateParts(lesson.starts_at).day}</div>
                                    <div className={styles.weekday}>{capitalize(parseDateParts(lesson.starts_at).weekday)}</div>
                                    <div className={styles.time}>
                                        <ClockIcon className={styles.clockIcon} />
                                        {formatTimeV2(lesson.starts_at)} - {formatTimeV2(lesson.ends_at)}
                                    </div>
                                </div>
                            )
                        }} />
                    </div>
                </>
            }
            {loading &&
                <>
                    <div className={styles.header}>
                        <Skeleton borderRadius="4px" width="100%" height="20px" style={{ margin: '0.5rem 0' }} />
                    </div>

                    <div className={styles.lessons}>
                        <Each of={Array(3).fill(null)} render={(_, index) => {
                            return (
                                <Skeleton key={index} borderRadius="10px" width="350px" height="55px" style={{ marginBottom: '0.5rem' }} />
                            )
                        }} />
                    </div>
                </>
            }
        </div>
    )
}

export default EditionLessonsCard